import { render, staticRenderFns } from "./PluginEmbed.vue?vue&type=template&id=d680440a"
import script from "./PluginEmbed.vue?vue&type=script&lang=js"
export * from "./PluginEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d680440a')) {
      api.createRecord('d680440a', component.options)
    } else {
      api.reload('d680440a', component.options)
    }
    module.hot.accept("./PluginEmbed.vue?vue&type=template&id=d680440a", function () {
      api.rerender('d680440a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginEmbed.vue"
export default component.exports